import { initClickTracking } from './click-tracking';

const fixedBanner = document.querySelector('.js-fixed-banner');
const fixedBannerCloseButton = document.querySelector('.js-fixed-banner-close');
const fixedBannerSideBox = document.querySelector('.js-fixed-banner-side-box');

const storageKey = 'fixed-banner';
const timeInterval = 28800000; // 8 hours in milliseconds (8 * 60 * 60 * 1000)
const fixedBannerLink = document.querySelector('.js-fixed-banner-link');

if (fixedBanner)
{
    fixedBannerCloseButton.addEventListener('click', hideBanner);
    fixedBannerSideBox.addEventListener('click', showBanner);
}

function initBanner()
{
    let storedData = getStorage();
    if (fixedBanner)
    {
        if (storedData)
        {
            let { closedTimestamp, teaserHref } = JSON.parse(storedData);
            let currentTimestamp = new Date().getTime();

            if (currentTimestamp - closedTimestamp > timeInterval || teaserHref !== fixedBannerLink.href)
            {
                localStorage.removeItem(storageKey);
                showBanner();
            }
            else
            {
                hideBanner();
            }
        }
        else
        {
            showBanner();
        }
    }
}

function showBanner()
{
    fixedBanner.classList.remove('close-to-side');
    fixedBanner.classList.remove('fixed-banner__closed');
    fixedBannerSideBox.classList.add('hidden');

    dispatchBannerOpenEvent();
    removeStorage();
}

function hideBanner()
{
    fixedBanner.classList.add('close-to-side');

    fixedBanner.addEventListener('animationend', () =>
    {
        if (fixedBanner.classList.contains('close-to-side'))
        {
            fixedBanner.classList.add('fixed-banner__closed');
            dispatchBannerClosedEvent();
        }
    });

    fixedBannerSideBox.classList.remove('hidden');

    setStorage();
}

function dispatchBannerClosedEvent()
{
    const event = new CustomEvent('fixedBannerClosed');
    document.dispatchEvent(event);
}

function dispatchBannerOpenEvent()
{
    const event = new CustomEvent('fixedBannerOpen');
    document.dispatchEvent(event);
}

function getStorage()
{
    return localStorage.getItem(storageKey);
}

function setStorage()
{
    let data = {
        closedTimestamp: new Date().getTime(),
        teaserHref: fixedBannerLink.href
    };

    localStorage.setItem(storageKey, JSON.stringify(data));
}

function removeStorage()
{
    localStorage.removeItem(storageKey);
}

initBanner();

initClickTracking();
